import PageContainer from "@components/layout/PageContainer";
import ClientSettlementsReportForm from "@components/dynamic/ClientSettlementsReportForm";

const ClientSettlementsReport = () => {
  return (
    <PageContainer
      title="Reporte de Liquidaciones"
      backUrl="/user/dashboard-accounting"
    >
      <ClientSettlementsReportForm />
    </PageContainer >
  );
}

export default ClientSettlementsReport;
